import { BrowserRouter as Router } from "react-router-dom";
import "./styles/App.css";
import "@amzn/meridian";
import { PreferenceProvider } from "./context/PreferenceContext";
import { FeatureFlagsProvider } from "./context/FeatureFlagsContext";
import AppRoutes from "./AppRoutes";

const App = () => (
  <FeatureFlagsProvider>
    <PreferenceProvider>
      <Router>
        <AppRoutes />
      </Router>
    </PreferenceProvider>
  </FeatureFlagsProvider>
);

export default App;
